module.exports = __webpack_public_path__ + "static/img/dakota-corbin-PmNjS6b3XP4-unsplash_thumb.3a56ab1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/dakota-corbin-PmNjS6b3XP4-unsplash_thumb.png
// module id = J24l
// module chunks = 4